import { Fragment, useState, useEffect } from "react";

import MenuItem from "@mui/material/MenuItem";

import MySelectField from "components/Inputs/MySelectField";
import { vehiclePassengers } from "services/constants";

const VehiclePassengersSelect = (props) => {
  const { value, updateValues, myCompany } = props;
  const [choices, setChoices] = useState([]);

  useEffect(() => {
    if (myCompany?.only_cargo == false) {
      setChoices(vehiclePassengers);
    } else {
      setChoices([vehiclePassengers[0]]);
    }
  }, [myCompany]);

  const handleSelectChange = ({ target }) => {
    updateValues({ [target.name]: target.value });
  };

  return (
    <Fragment>
      <MySelectField
        id="select_order_type"
        name="max_passanger"
        value={value ? value : 0}
        onChange={handleSelectChange}
      >
        {choices.map((option) => (
          <MenuItem key={option.key} value={option.key}>
            {option.value}
          </MenuItem>
        ))}
      </MySelectField>
    </Fragment>
  );
};

export default VehiclePassengersSelect;
